import {createStylesContext} from '@chakra-ui/system';

const ComponentName = `Nav` as const;
export const [StylesProvider, useStyles] = createStylesContext(ComponentName);
